import {
  AlertColor,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import NumberFormat, { NumberFormatProps } from "react-number-format";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumberFormatCustom = React.forwardRef<NumberFormatProps, CustomProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        decimalSeparator=","
        thousandSeparator="."
        isNumericString
        allowEmptyFormatting
        allowNegative={false}
        prefix="R$ "
      />
    );
  }
);

type ChangeValueDialogProps = {
  open: boolean;
  trocoAtual: bigint;
  handleClose: (valorTroco: bigint) => void;
  showSnackbarMessage: (options: {message: string; severity: AlertColor;}) => void,
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
};

/**
 * para informar o troco (change)
 * o troco é retornado via a função handleClose, e aí o caller pode fazer o que quiser com ele
 * @param open
 * @param handleClose
 * @param shoppingBagQuery
 * @param showSnackbarMessage
 * @param trocoAtual
 * @constructor
 */
function ChangeValueDialog({ open, handleClose,shoppingBagQuery,showSnackbarMessage, trocoAtual }: ChangeValueDialogProps) {
  const {data: shoppingBag} = shoppingBagQuery
  const formik = useFormik({
    initialValues: {
      change_value: trocoAtual,
    },
    enableReinitialize: false,
    onSubmit: async (values: any, ) => {
      handleCloseDialog(values)
      values.change_value = 0
    },
  });

  const handleCloseDialog = (values: any) => {
    if(!shoppingBag) return;

    if(values.change_value === undefined) values.change_value = 0
    if(isNaN(Number(values.change_value))) values.change_value = 0

    let trocoOriginal = values.change_value + ''
    trocoOriginal = trocoOriginal.replace('.', ',')
    const depoisDaVirgula = trocoOriginal.split(',')[1]

    let trocoInteiro = trocoOriginal.split(',')[0]

    if(depoisDaVirgula) {
      if(depoisDaVirgula.length === 1) {
        trocoInteiro += '0'
      }

      if( depoisDaVirgula.length === 0) {
        trocoInteiro += '00'
      }

      if(depoisDaVirgula.length >= 2) {
        trocoInteiro += depoisDaVirgula.substring(0, 2)
      }
    }
    else {
      trocoInteiro += '00'
    }

    if(Number(trocoInteiro)===0) {
      handleClose(BigInt(0))
      formik.values.change_value = BigInt(0)
      return;
    }

    if (Number(trocoInteiro) / 100 > shoppingBag.total) {

      const valorTroco = BigInt(trocoInteiro)
      handleClose(valorTroco ?? BigInt(0));
      return;
    }

    showSnackbarMessage({message: 'Valor do troco é menor ou igual que o valor total, o troco será zero.', severity: 'error'})
    handleClose(BigInt(0));
    formik.values.change_value = BigInt(0)
  }

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Vai precisar de troco?</DialogTitle>
      <DialogContent>
        <form noValidate onSubmit={formik.handleSubmit}>
          <Box>
            <TextField
              value={formik.values.change_value}
              onChange={formik.handleChange}
              placeholder="Troco para:"
              name="change_value"
              id="formatted-numberformat-input"
              InputProps={{
                inputComponent: NumberFormatCustom as any,
              }}
              variant="standard"
            />
          </Box>
          <Box display={"flex"} flexGrow={1}>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              sx={{ color: "white", marginTop: "15px", width: "50%" }}
            >
              Sim
            </Button>
            <Button
              color="primary"
              variant="outlined"
              sx={{ marginTop: "15px", width: "50%", marginLeft: 2 }}
              onClick={() => handleCloseDialog({value:{change_value: 0}}) }
            >
              Não
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default ChangeValueDialog;
